export default __webpack_public_path__ + "static/media/instagram_impreza.2fe89eec.jpg";